import { request } from './repository';

const url = 'roles/';


const roleRepository = {
    getRoles(params) {
        return request.get(url, params);
    },

    updateRoles(form) {
        return request.post(url + 'sync-roles', form);
    },

    getRemainingPermissions(id, params) {
        return request.get('permission/get-remaining-permissions/' + id, params);
    },

    getPermissionsByID(id, params) {
        return request.get(url + 'get-permissions/by-role-id/' + id, params);
    },

    addPermissions(data) {
        return request.post('role-has-permission/store', data);
    },

    removePermissions(data) {
        return request.post('role-has-permission/remove', data);
    }
}

export default roleRepository;
